"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapManager = exports.dustEmitter = exports.emitter = void 0;
const constants_1 = __importDefault(require("../shared/constants"));
const create_1 = require("./create");
const game_js_1 = require("./game.js");
const collisions_1 = require("../shared/collisions");
const utils_1 = require("../server/utils");
const uiScene_1 = require("./uiScene");
const mapManagerConfig_1 = require("./mapManagerConfig");
function createBoxFromTiled(collisions, obj) {
    const angle = (0, utils_1.degreesToRadians)(obj.rotation);
    const offset = {
        x: 0,
        y: obj.height * -1
    };
    (0, utils_1.rotate)(offset, angle);
    const box = (0, collisions_1.createBox)(collisions, obj.x + offset.x, obj.y + offset.y, obj.width, obj.height, { angle: angle });
    if (obj.properties) {
        obj.properties.forEach(property => {
            box[property.name] = property.value;
        });
    }
    return box;
}
class MapManager {
    constructor(phaserData) {
        this.phaserData = phaserData;
        this.mapObjectsMain = {};
        this.mapObjectsCollision = [];
        this.mapObjectsText = [];
        this.mapLoaded = false;
        this.ignoreList = ['Campfire', 'spikeTrapOn', 'spikeTrapOff'];
    }
    isMapLoaded() {
        return this.mapLoaded;
    }
    transformTiledToPhaser(objectInstance, object) {
        objectInstance.x = object.x;
        objectInstance.y = object.y;
        var offset = {
            x: objectInstance.originX * object.width,
            y: (objectInstance.originY - (object.gid ? 1 : 0)) * object.height
        };
        if (object.rotation) {
            const angle = (0, utils_1.degreesToRadians)(object.rotation);
            (0, utils_1.rotate)(offset, angle);
            objectInstance.rotation = angle;
        }
        else {
            objectInstance.rotation = 0;
        }
        objectInstance.x += offset.x;
        objectInstance.y += offset.y;
        objectInstance.visible = true;
        objectInstance.active = true;
        objectInstance.displayHeight = object.height;
        objectInstance.displayWidth = object.width;
        objectInstance.alpha = 1;
        objectInstance.tint = 0xffffff;
        if (object.flippedHorizontal !== undefined || object.flippedVertical !== undefined) {
            objectInstance.setFlip(object.flippedHorizontal, object.flippedVertical);
        }
    }
    createPooledObjects(layer, passedObjectType) {
        if (this.ignoreList.includes(passedObjectType)) {
            return [];
        }
        let objectLayer = this.phaserData.map.getObjectLayer(layer);
        if (!objectLayer) {
            return [];
        }
        const objects = objectLayer.objects;
        let addedObjects = [];
        for (let i = objects.length - 1; i >= 0; i--) {
            let object = objects[i];
            if (object.pooledType) {
                object.type = object.pooledType;
                object.gid = object.pooledGid;
                object.pooledType = null;
            }
            const objectType = object.type;
            if (passedObjectType !== objectType || !create_1.entityPoolManager.poolExists('objects', passedObjectType) || create_1.entityPoolManager.getPoolSize('objects', passedObjectType) == 0) {
                continue;
            }
            let objectInstance = create_1.entityPoolManager.getObjectFromPool('objects', passedObjectType);
            if (objectInstance) {
                this.transformTiledToPhaser(objectInstance, object);
                object.pooledType = objectType;
                object.pooledGid = object.gid;
                object.type = null;
                object.gid = null;
                addedObjects.push(objectInstance);
            }
        }
        return addedObjects;
    }
    createObject(layer, GID, spriteKey, depth, frame, imgName, tint, ignore, objectType, isShadow) {
        let objectConfig;
        if (layer == 'GeneralObjects' || layer == 'Decoration' || layer == 'MovementImpairingFloor' || layer == 'Smudges' || layer == 'SmallDecorations' || layer == 'Rounders' || layer == 'MinZones') {
            objectConfig = {
                'key': 'mainAssets', 'frame': imgName,
                'gid': GID
            };
        }
        else {
            objectConfig = {
                'key': spriteKey,
                'gid': GID
            };
        }
        frame ? objectConfig.frame = frame : null;
        let pooledObjects = this.createPooledObjects(layer, objectType);
        let createdFromObjects = this.phaserData.map.createFromObjects(layer, objectConfig);
        const objectInstancing = createdFromObjects.concat(pooledObjects);
        // Testing //////////////////////////////////////////////
        if (layer === 'Smudges' && objectType === 'forest_smudge_16') {
            console.log("[DEBUG] CREATING FOREST SMUDGE LAYER", {
                layer: layer,
                pooledObjects: pooledObjects.length,
                createdFromObjects: createdFromObjects.length,
                objectInstancing: objectInstancing.length
            });
        }
        if (layer === 'GeneralObjects' && objectType === 'Rock') {
            console.log("[DEBUG] CREATING ROCK LAYER", {
                layer: layer,
                pooledObjects: pooledObjects.length,
                createdFromObjects: createdFromObjects.length,
                objectInstancing: objectInstancing.length
            });
        }
        // Ending testing //////////////////////////////////////////
        let ratio = 1;
        if (constants_1.default.TILED_PARSE_COMMANDS[objectType]) {
            ratio = constants_1.default.TILED_PARSE_COMMANDS[objectType];
        }
        for (let i = 0; i < objectInstancing.length; i++) {
            if (depth) {
                objectInstancing[i].setDepth(depth);
            }
            else {
                objectInstancing[i].setDepth(constants_1.default.DEPTHS.floorObjects);
            }
            if (tint) {
                objectInstancing[i].tint = tint;
            }
            if (spriteKey == 'campfire_256') {
                let circle = this.phaserData.add.circle(objectInstancing[i].x, objectInstancing[i].y, ((objectInstancing[i].width * objectInstancing[i].scaleX) / 2) * 1.2, 0xfede17, 0.15);
                // circle.setDepth(0 + 1)
                circle.setDepth(constants_1.default.DEPTHS.floorObjects);
                this.phaserData.tweens.add({
                    targets: circle,
                    t: 1,
                    ease: 'Sine.easeInOut',
                    scaleX: 1.5,
                    scaleY: 1.5,
                    duration: 2000,
                    yoyo: true,
                    repeat: -1
                });
                objectInstancing[i].campfireCircle = circle;
                this.mapObjectsCollision.push(circle);
            }
            if (layer == 'GeneralObjects' || layer == 'Decoration' || layer == 'MovementImpairingFloor' || layer == 'Smudges' || layer == 'SmallDecorations' || layer == 'Rounders' || layer == 'MinZones') {
                let circle;
                if (constants_1.default.NETWORKING == 'CAUTH' && !isShadow) {
                    if (layer === 'GeneralObjects') {
                        circle = (0, collisions_1.createCircle)(game_js_1.collisions, objectInstancing[i].x, objectInstancing[i].y, (ratio * objectInstancing[i].width * objectInstancing[i].scaleX) / 2);
                        this.mapObjectsCollision.push(circle);
                    }
                    else if (objectType === 'Campfire') {
                        circle = (0, collisions_1.createCircle)(game_js_1.collisions, objectInstancing[i].x, objectInstancing[i].y, (0.3 * objectInstancing[i].width * objectInstancing[i].scaleX) / 2);
                        this.mapObjectsCollision.push(circle);
                    }
                }
                objectInstancing[i].visible = false;
                objectInstancing[i].active = false;
                if (layer == 'MovementImpairingFloor') {
                    create_1.bigCullingManager.addEntity(objectInstancing[i]);
                }
                else {
                    create_1.cullingManager.addEntity(objectInstancing[i]);
                }
                if (objectInstancing[i].campfireCircle) {
                    create_1.cullingManager.addEntity(objectInstancing[i].campfireCircle);
                }
            }
        }
        if (layer == 'Smudges' || layer == 'SmallDecorations' || layer == 'Rounders' ||
            // layer == 'GeneralObjects' ||
            layer == 'decoration' ||
            ignore) {
            uiScene_1.minimapManager.ignoreEntity(objectInstancing);
        }
        if (objectInstancing.length > 0) {
            if (!this.mapObjectsMain[objectType]) {
                this.mapObjectsMain[objectType] = objectInstancing;
            }
            else {
                this.mapObjectsMain[objectType] = this.mapObjectsMain[objectType].concat(objectInstancing);
            }
        }
        return objectInstancing;
    }
    removeMap() {
        this.mapLoaded = false;
        // Destroying mapObjectsText
        for (let i = 0; i < this.mapObjectsText.length; i++) {
            this.mapObjectsText[i].destroy();
        }
        // Removing mapObjectsCollision
        for (let i = 0; i < this.mapObjectsCollision.length; i++) {
            if (this.mapObjectsCollision[i]) {
                (0, collisions_1.removeBody)(game_js_1.collisions, this.mapObjectsCollision[i]);
            }
        }
        // Destroying mapObjectsMain groups
        for (const [spriteType, sprites] of Object.entries(this.mapObjectsMain)) {
            let deleteSprite = false;
            if (this.ignoreList.includes(spriteType)) {
                deleteSprite = true;
            }
            for (let i = 0; i < sprites.length; i++) {
                if (deleteSprite) {
                    if (spriteType === 'Campfire') {
                        if (sprites[i].campfireCircle) {
                            sprites[i].campfireCircle.destroy();
                        }
                    }
                    sprites[i].destroy();
                }
                else {
                    sprites[i].visible = false;
                    create_1.entityPoolManager.addObjectToPool('objects', spriteType, sprites[i]);
                }
            }
            sprites.length = 0;
        }
        this.mapObjectsMain = {};
        // Cleanup
        this.mapObjectsText.length = 0;
        this.mapObjectsCollision.length = 0;
        // Destroying the Phaser map
        this.phaserData.map.destroy();
        this.phaserData.map = undefined;
        this.mapName = undefined;
    }
    createMap(phaserData, videoSettings, gameName = 'mainportal', portal = false) {
        let mapJSON;
        let portalPrefix = '';
        if (portal) {
            mapJSON = require(`../../public/assets/mainPortal/map/${gameName}${constants_1.default.MAP_JSON_NAME}`);
            portalPrefix = 'portal';
        }
        else {
            mapJSON = require(`../../public/assets/games/${gameName}/map/${constants_1.default.MAP_JSON_NAME}`);
        }
        this.phaserData.map = phaserData.make.tilemap({
            key: `${portalPrefix}map${gameName}`
        });
        this.mapName = gameName;
        let gid_dict = {};
        let objectRefDict = {};
        // load GID Dict 
        for (let i = 0; i < mapJSON.tilesets.length; i++) {
            let firstGid = mapJSON.tilesets[i].firstgid;
            for (let b = 0; b < mapJSON.tilesets[i].tiles.length; b++) {
                let gidID = firstGid + mapJSON.tilesets[i].tiles[b].id;
                let type = mapJSON.tilesets[i].tiles[b].type;
                gid_dict[type] = gidID;
            }
        }
        let circlePointLayer = mapJSON.layers.filter(layer => layer.name == 'CirclePoints');
        for (let i = 0; i < circlePointLayer[0].objects.length; i++) {
            game_js_1.circlePointDict[circlePointLayer[0].objects[i].name] = {
                height: circlePointLayer[0].objects[i].height,
                width: circlePointLayer[0].objects[i].width,
                x: circlePointLayer[0].objects[i].x,
                y: circlePointLayer[0].objects[i].y,
            };
        }
        game_js_1.mapCenter.x = game_js_1.circlePointDict['circlePoint1']['x'];
        game_js_1.mapCenter.y = game_js_1.circlePointDict['circlePoint1']['y'];
        for (let [key, value] of Object.entries(game_js_1.circlePointDict)) {
            game_js_1.circlePointDict[key]['distance'] = game_js_1.circlePointDict[key]['width'] / 2;
        }
        // For Depth guidances, see Constants.DEPTHS
        // --- Floor ---
        let floorTileset = phaserData.map.addTilesetImage('Floor', 'floorSpritesheet', 16, 16, 3, 6);
        phaserData.map.createLayer('Floor', floorTileset);
        //  --- Objects ---
        let parsedObjectConfigs = mapManagerConfig_1.objectConfigs;
        if (videoSettings.smallDecorations === false) {
            parsedObjectConfigs = parsedObjectConfigs.filter(config => config.layer != 'SmallDecorations');
        }
        if (videoSettings.smudges === false) {
            parsedObjectConfigs = parsedObjectConfigs.filter(config => config.layer != 'Smudges');
        }
        let subObject;
        if (constants_1.default.NETWORKING == 'CAUTH') {
            phaserData.map.filterObjects('BaseBlocker', obj => {
                subObject = createBoxFromTiled(game_js_1.collisions, obj);
                this.mapObjectsCollision.push(subObject);
            });
            phaserData.map.filterObjects('MinZones', obj => {
                subObject = createBoxFromTiled(game_js_1.collisions, obj);
                this.mapObjectsCollision.push(subObject);
            });
        }
        // --- Text ---
        const textLayer = mapJSON.layers.filter(object => object.name === 'Text');
        if (textLayer && textLayer[0] && textLayer[0].objects && textLayer[0].objects.length > 0) {
            for (let i = 0; i < textLayer[0].objects.length; i++) {
                let fontObj = {
                    fontFamily: textLayer[0].objects[i].text.fontfamily, fontSize: textLayer[0].objects[i].text.pixelsize + 'px', color: '#000000'
                };
                if (textLayer[0].objects[i].text.color) {
                    fontObj.color = textLayer[0].objects[i].text.color;
                }
                console.log("FONT OBJECT", fontObj);
                subObject = this.phaserData.add.text(textLayer[0].objects[i].x, textLayer[0].objects[i].y, textLayer[0].objects[i].text.text, fontObj);
                this.mapObjectsText.push(subObject);
            }
        }
        for (let i = 0; i < parsedObjectConfigs.length; i++) {
            if (parsedObjectConfigs[i].reference) {
                // --- Spike Traps ---
                objectRefDict[parsedObjectConfigs[i].type] = this.createObject(parsedObjectConfigs[i].layer, gid_dict[parsedObjectConfigs[i].type], parsedObjectConfigs[i].spriteKey, parsedObjectConfigs[i].depth, parsedObjectConfigs[i].frame, parsedObjectConfigs[i].imgName, parsedObjectConfigs[i].tint, parsedObjectConfigs[i].ignore, parsedObjectConfigs[i].type, false);
            }
            else {
                // --- Shadows ---
                if (videoSettings.shadows !== false) {
                    if (parsedObjectConfigs[i].shadow) {
                        let shadow = this.createObject(parsedObjectConfigs[i].layer, gid_dict[parsedObjectConfigs[i].type], parsedObjectConfigs[i].spriteKey, parsedObjectConfigs[i].depth, parsedObjectConfigs[i].frame, parsedObjectConfigs[i].imgName, parsedObjectConfigs[i].tint, parsedObjectConfigs[i].ignore, parsedObjectConfigs[i].type, true);
                        for (let j = 0; j < shadow.length; j++) {
                            if (parsedObjectConfigs[i].shadow == 1) {
                                shadow[j].x = shadow[j].x + 4;
                                shadow[j].y = shadow[j].y + 3;
                            }
                            else if (parsedObjectConfigs[i].shadow == 3) {
                                shadow[j].x = shadow[j].x + 10;
                                shadow[j].y = shadow[j].y + 8;
                            }
                            shadow[j].setDepth(constants_1.default.DEPTHS.shadow);
                            shadow[j].tint = constants_1.default.SHADOW_TINT;
                            shadow[j].alpha = constants_1.default.SHADOW_ALPHA;
                            uiScene_1.minimapManager.ignoreEntity(shadow[j]);
                        }
                        uiScene_1.minimapManager.ignoreEntity(shadow);
                    }
                }
                this.createObject(parsedObjectConfigs[i].layer, gid_dict[parsedObjectConfigs[i].type], parsedObjectConfigs[i].spriteKey, parsedObjectConfigs[i].depth, parsedObjectConfigs[i].frame, parsedObjectConfigs[i].imgName, parsedObjectConfigs[i].tint, parsedObjectConfigs[i].ignore, parsedObjectConfigs[i].type, false);
            }
        }
        let spikeDict = {
            'spikeSwitch': false,
            'spikesOn': objectRefDict['spikeTrapOn'],
            'spikesOff': objectRefDict['spikeTrapOff'],
        };
        let lavaDict = {
            'lavaPit': false,
            'lavaOn': objectRefDict['lavaPitOn'],
            'lavaOff': objectRefDict['lavaPitOff'],
        };
        // Create object dict of sprites that need to be modified later
        let objectDict = {
            'spikeDict': spikeDict,
            'lavaDict': lavaDict
        };
        this.mapLoaded = true;
        if (exports.emitter) {
            exports.emitter.destroy();
            exports.emitter = null;
        }
        exports.emitter = create_1.phaserObject.add.particles(0, 0, 'flares', {
            frame: ['red', 'yellow', 'green'],
            lifespan: 1000,
            speed: { min: 50, max: 150 },
            scale: { start: 0.5, end: 0 },
            gravityY: 150,
            blendMode: 'ADD',
            emitting: false
        });
        exports.emitter.setDepth(constants_1.default.DEPTHS.floorObjects);
        if (exports.dustEmitter) {
            exports.dustEmitter.destroy();
            exports.dustEmitter = null;
        }
        exports.dustEmitter = create_1.phaserObject.add.particles(0, 0, 'dirt', ({
            lifespan: 400,
            speed: { min: -30, max: 30 },
            angle: { min: 0, max: 360 },
            scale: { start: 0.085, end: 0 },
            alpha: { start: 7, end: 0 },
            gravityY: 10,
            blendMode: 'ADD',
            emitting: false // Ensure particles don't emit automatically
        }));
        exports.dustEmitter.setDepth(constants_1.default.DEPTHS.floorObjects);
        return objectDict;
    }
}
exports.MapManager = MapManager;
